import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["search", "item", "empty"]

  filter() {
    const query = this.searchTarget.value.trim().toLowerCase()
    let visibleCount = 0

    this.itemTargets.forEach((item) => {
      const matches = item.dataset.iconName.includes(query)
      item.classList.toggle('d-none', !matches)
      if (matches) visibleCount++
    })

    this.emptyTarget.classList.toggle('d-none', visibleCount > 0)
  }

  select(event) {
    const name = event.currentTarget.dataset.iconName
    if (name) {
      this.dispatchIconSelected(name)
      this.closeModal()
    }
  }

  dispatchIconSelected(name) {
    window.dispatchEvent(new CustomEvent('tinymce:iconSelected', {
      detail: { name },
      bubbles: true
    }))
  }

  closeModal() {
    const modalElement = document.querySelector('#modalWindow')
    if (modalElement) {
      const modal = Modal.getInstance(modalElement)
      if (modal) modal.hide()
    }
  }
}
